import React, { useContext, useState, useEffect } from 'react';
import { Form, Button } from '@themesberg/react-bootstrap';
import { Context } from '../../../../context/Context';
import { CartContext } from '../../../../context/CartContext';
import axios from '../../../../config/axios';
import { simpleAlert } from "../../../alerts/Alerts";
import { useNavigate } from "react-router-dom";

const CartForm = () => {
    const navigate = useNavigate();
    const [auth] = useContext(Context);
    const { cart } = useContext(CartContext);
    
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
    });

    useEffect(() => {
        if (auth) {
            setFormData({
                firstName: auth.first_name || '',
                lastName: auth.last_name || '',
                email: auth.email || '',
            });
        }
    }, [auth]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const orderData = {
            user_id: auth.user_id,
            client_id: auth.id,
            billing_first_name: formData.firstName,
            billing_last_name: formData.lastName,
            //order_total: cart.reduce((total, item) => total + (item.variant.price * item.quantity), 0),
            order_items: cart.map(item => ({
                product_id: item.productId,
                sku: item.variant.sku,
                item_name: item.variant.title,
                qty: item.quantity,
                option: item.variant.title === "Default Title" ? null : item.variant.title,
                //unitary_price_1: item.variant.price.toFixed(2),
                //unitary_price_tax_1: (item.variant.price * 1.19).toFixed(2),
                //unitary_price_2: Math.floor(item.variant.price),
                //unitary_price_tax_2: Math.floor(item.variant.price * 1.19),
                //discounted_value_1: (item.variant.price * 0.15).toFixed(2),
                //discounted_value_2: Math.floor(item.variant.price * 0.15),
                //base_price_2: Math.floor(item.variant.price * 0.85),
                //tax_percentage: 19,
                //tax: ((item.variant.price * 0.19).toFixed(2)),
                //line_total_1: Math.floor(item.variant.price * 0.85),
                //line_total_2: Math.floor(item.variant.price * 1.19),
                //cupon_produc_value: null,
                //cupon_servic_value: null,
                //branch_id: null,
                //branch_name: null,
            }))
        };

        console.log('📦 JSON enviado:', JSON.stringify(orderData, null, 2));
        
        // Aquí podrías hacer un fetch o axios.post para enviar orderData a tu API

        const response = await axios.post('order/create/toppo', orderData);
            simpleAlert(
                'Correcto',
                'success',
                'Orden creada correctamente',
            );

            //clearCart();

            navigate('/dashboard/orders');

    };

    return (
        <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formFirstName">
                <Form.Label>Nombre</Form.Label>
                <Form.Control
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                />
            </Form.Group>

            <Form.Group controlId="formLastName">
                <Form.Label>Apellido</Form.Label>
                <Form.Control
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                />
            </Form.Group>

            <Form.Group controlId="formEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                />
            </Form.Group>

            <Button variant="primary w-100" type="submit" className='mt-4'>
                Finalizar Compra
            </Button>
        </Form>
    );
};

export default CartForm;
